<app-add-file-upload></app-add-file-upload>
<app-file-upload-detail></app-file-upload-detail>
